// extracted by mini-css-extract-plugin
module.exports = {"page":"_2B37y","content":"guiTU","title":"_23KHW","info":"_3AeH4","operation":"R--vh"};